import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { context } from "./context";
import "./index.css";
import store from "./store";

Sentry.init({
  dsn: "https://60c9742ed01ca9ee3311d7a12e8fc17f@o4508937566945280.ingest.us.sentry.io/4508971463737344",
  environment: context.env || "local",
  integrations: [
    // Add browser profiling integration to the list of integrations
    Sentry.browserProfilingIntegration(),
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Let's sample 10% of sessions for traces
  tracesSampleRate: 0.1,
  tracePropagationTargets: ["localhost", /^https:\/\/([a-z0-9]+[.])*canna42[.]com/g],
  profilesSampleRate: 0.1, // This is relative to tracesSampleRate so this will profile 1% of total sessions.
  replaysSessionSampleRate: 0.001, // Let's sample 1% of sessions for replay
  replaysOnErrorSampleRate: 0.25, // When an error happens, let's replay 25% of sessions
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);

// TODO: decode the JWT locally to see if the user is an admin and apart of the cann42-admins group

// TODO: if user doesnt have access to a business, redirect them to the home page.
